import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const KindSchema = z.object({ kind: z.enum(["offert", "elpris"]) });

const NotFoundSchema = z.object({
  path: z.string().trim().min(1).max(500),
  referrer: z.string().trim().max(500).optional(),
  userAgent: z.string().trim().max(300).optional(),
});

/** Antal unika besökare senaste 24h som jämfört elpriser/offerter. */
export const getDailyCompareCount = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => KindSchema.parse(data))
  .handler(async ({ data }) => {
    const { fetchDailyCompareCount } = await import("./siteMetrics.server");
    return { count: await fetchDailyCompareCount(data.kind) };
  });

/** Loggar en 404-träff så vi kan lägga in omdirigeringar för gamla URL:er. */
export const logNotFound = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => NotFoundSchema.parse(data))
  .handler(async ({ data }) => {
    const { recordNotFound } = await import("./siteMetrics.server");
    await recordNotFound(data);
    return { ok: true as const };
  });
